'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UIWellItem from 'UIComponents/well/UIWellItem';
import UIWellLabel from 'UIComponents/well/UIWellLabel';
import UIWell from 'UIComponents/well/UIWell';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIWellBigNumber from 'UIComponents/well/UIWellBigNumber';
import NumberSkeleton from './NumberSkeleton';
import ROIValue, { ROITooltip } from './ROIValue';
import styled from 'styled-components';
import { getCurrencySymbol, getNameFromCurrencySymbol } from 'AdsUI/lib/Utils';
import { AdSpendCurrencyChoices } from 'AdsUI/lib/Constants';
import CurrencyValue from './CurrencyValue';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import GoToCurrencySettings from './GoToCurrencySettings';
import Small from 'UIComponents/elements/Small';
import UICardSection from 'UIComponents/card/UICardSection';
import UIList from 'UIComponents/list/UIList';
import AdSpendCurrencyChoiceLink from './AdSpendCurrencyChoiceLink';
const NoWrap = styled.div.withConfig({
  displayName: "WellsSpendROI__NoWrap",
  componentId: "nq6lxo-0"
})(["white-space:nowrap;.roi-calculate-link-container{font-size:16px;}"]);

const AdSpendLabel = ({
  adSpendCurrencyChoice
}) => {
  return /*#__PURE__*/_jsx(UIHelpIcon, {
    title: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs("p", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: `campaigns.multiCurrencyTooltip.wellsSpendRoi.spendTooltip.${adSpendCurrencyChoice}`
        }), ' ', adSpendCurrencyChoice === AdSpendCurrencyChoices.PORTAL && /*#__PURE__*/_jsx(GoToCurrencySettings, {
          textKey: "setUpConversion"
        })]
      }), /*#__PURE__*/_jsx(AdSpendCurrencyChoiceLink, {
        messageJsx: adSpendCurrencyChoice === AdSpendCurrencyChoices.NETWORK ? 'campaigns.multiCurrencyTooltip.wellsSpendRoi.networkText_jsx' : null
      })]
    }),
    tooltipPlacement: "bottom left",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaigns.adSpend"
    })
  });
};

const WellsSpendROI = ({
  data,
  loading,
  adSpendCurrencyChoice
}) => {
  const noCurrencyConversion = !loading && data.roiConverted && data.convertedCost.amount === null;
  return /*#__PURE__*/_jsxs(UICardSection, {
    className: "p-y-0",
    children: [/*#__PURE__*/_jsxs(UIWell, {
      wrapItems: false,
      children: [/*#__PURE__*/_jsxs(UIWellItem, {
        className: noCurrencyConversion ? 'm-bottom-0' : '',
        children: [/*#__PURE__*/_jsx(UIWellLabel, {
          children: /*#__PURE__*/_jsx(AdSpendLabel, {
            adSpendCurrencyChoice: adSpendCurrencyChoice
          })
        }), /*#__PURE__*/_jsx(UIWellBigNumber, {
          children: loading ? /*#__PURE__*/_jsx(NumberSkeleton, {
            size: "large"
          }) : noCurrencyConversion ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "notApplicableAbbreviation"
          }) : /*#__PURE__*/_jsx(CurrencyValue, {
            value: data.roiCost.amount,
            currencySymbol: getCurrencySymbol(data.roiCost.currencyCode)
          })
        })]
      }), /*#__PURE__*/_jsxs(UIWellItem, {
        className: noCurrencyConversion ? 'm-bottom-0' : '',
        children: [/*#__PURE__*/_jsx(UIWellLabel, {
          children: /*#__PURE__*/_jsx(ROITooltip, {
            data: data,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "roi"
            })
          })
        }), /*#__PURE__*/_jsx(UIWellBigNumber, {
          children: loading ? /*#__PURE__*/_jsx(NumberSkeleton, {
            size: "large"
          }) : noCurrencyConversion ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "notApplicableAbbreviation"
          }) : /*#__PURE__*/_jsx(NoWrap, {
            children: /*#__PURE__*/_jsx(ROIValue, {
              data: data,
              withLabel: false,
              showHelpIcon: false
            })
          })
        })]
      })]
    }), noCurrencyConversion && /*#__PURE__*/_jsx(Small, {
      use: "help",
      className: "display-block text-center m-bottom-6 m-top-2",
      children: /*#__PURE__*/_jsx(UIHelpIcon, {
        title: data.inconvertibleCurrencies && data.inconvertibleCurrencies.length ? /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "campaigns.multiCurrencyTooltip.wellsSpendRoi.tooltipWithList"
            })
          }), /*#__PURE__*/_jsx(UIList, {
            styled: true,
            children: data.inconvertibleCurrencies.map(currency => /*#__PURE__*/_jsx("span", {
              children: getNameFromCurrencySymbol(currency)
            }, currency))
          }), /*#__PURE__*/_jsx(GoToCurrencySettings, {
            textKey: "setUpConversion"
          })]
        }) : /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "campaigns.multiCurrencyTooltip.wellsSpendRoi.tooltip"
          }), ' ', /*#__PURE__*/_jsx(GoToCurrencySettings, {})]
        }),
        tooltipPlacement: "top left",
        tooltipProps: {
          use: 'longform'
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaigns.multiCurrencyTooltip.wellsSpendRoi.message"
        })
      })
    })]
  });
};

export default WellsSpendROI;